import React, { useState, ChangeEvent } from 'react'
import {
  Button,
  LabeledTextarea,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooterAction,
  ModalHeader,
  ModalOverlay
} from '@apex/component-library'
import { Box, Flex, Text, Stack } from '@chakra-ui/react'
import { useCancelScheduleTransfer } from '../../api/useCancelScheduledTransfer'
import { payloadTransform } from './payloadTransform'
import { SelectedTransfer } from '../../containers/ScheduledTransfers/ScheduledTransfers'

export interface CancelScheduledTransferProps {
  selectedTransfer: SelectedTransfer
  onClose: () => void
  refetch: () => void
}

interface Comment {
  value: string
  error: string
}

export default function CancelScheduledTransfersModal({
  selectedTransfer: { id, direction, type },
  onClose,
  refetch
}: CancelScheduledTransferProps) {
  const [suppliedComment, setSuppliedComment] = useState<Comment>({ value: '', error: '' })

  const { mutate, isLoading } = useCancelScheduleTransfer()

  const handleCancelFinish = () => {
    onClose()
    refetch()
  }

  const handelSubmit = () => {
    mutate(payloadTransform(id, type, direction, suppliedComment.value), { onSettled: () => handleCancelFinish() })
  }

  const handelUpdateComment = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value
    const error = value.length > 2048 ? 'Maximum 2048 characters' : ''
    setSuppliedComment({ value, error })
  }

  return (
    <Modal isCentered isOpen={true} onClose={onClose}>
      <ModalOverlay>
        <ModalContent w='100%' maxW='550px'>
          <ModalHeader textStyle='h1'>Cancel Transfer Schedule</ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <Stack pb={8} spacing={8}>
              <Text>Canceling a schedule does not also cancel any corresponding transactions scheduled for today.</Text>
              <LabeledTextarea
                label='Comment (optional)'
                aria-label='Cancel Scheduled Transfer Comment'
                value={suppliedComment.value}
                onChange={handelUpdateComment}
                errorMessage={suppliedComment.error}
                isInvalid={!!suppliedComment.error}
              />
            </Stack>
          </ModalBody>

          <ModalFooterAction>
            <Flex>
              <Box ml='auto'>
                <Button variant='white' onClick={onClose} aria-label='Close Modal'>
                  Close
                </Button>
                <Button
                  variant='negative'
                  ml={3}
                  isLoading={isLoading}
                  onClick={handelSubmit}
                  isDisabled={!!suppliedComment.error}
                >
                  Cancel Schedule
                </Button>
              </Box>
            </Flex>
          </ModalFooterAction>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  )
}
